module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.articles) ? _c('div', {
    staticClass: "blog-list"
  }, [_vm._m(0), _c('section', {
    staticClass: "row"
  }, [_vm._t("before")], 2), _c('section', {
    staticClass: "row"
  }, [_vm._l((_vm.articles), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.articles.length > 0),
        expression: "articles.length > 0"
      }],
      key: item.id,
      staticClass: "col-lg-4 col-sm-6 col-12 d-flex mb-3"
    }, [_vm._t("item", null, null, {
      item: item,
      index: index
    })], 2)
  }), (!_vm.articles.length) ? _c('div', {
    staticClass: "blog-list_empty-articles"
  }, [_c('h2', [_vm._v("К сожалению, нет ни одной записи.")])]) : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "blog-list_head mb-2"
  }, [_c('h1', {
    staticClass: "blog__title"
  }, [_vm._v("Блог")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-099fe2b0","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/blog/list/List.vue
// module id = 66c31448d690eb688aad
// module chunks = 12